import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {ResidentForSelect, KeyLog} from '../../../types/data.types';
import {KeyLogService} from '../../../services/key-log.service';

declare const toastr: any;
declare const onDoneSign: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'sign-out-return-key-modal',
    templateUrl: './sign-out-return-key-modal.component.html',
    styleUrls: ['./sign-out-return-key-modal.component.scss']
})
export class SignOutReturnKeyModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    data: KeyLog = new KeyLog();
    disabledSubmit = false;
    signature = true;

    constructor(
        public api: ApiClientService,
        public keyLogService: KeyLogService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
        this.keyLogService.settingsLoaded.subscribe(data => this.disabledSubmit = false);
    }

    initData() {
        if (this.keyLogService.keyLoginKeyLogModal)
            this.data = this.keyLogService.keyLoginKeyLogModal;
        this.disabledSubmit = true;
        this.keyLogService.getSettingsForCorporation(this.keyLogService.buildings[0].corporationNumber);
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.keyLogService.returnKeyModal = false;
                    this.keyLogService.signOutKeyModal = false;
                    this.keyLogService.keyLoginKeyLogModal = null;
                    this.keyLogService.corporationSettings = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.keyLogService.returnKeyModal = false;
            this.keyLogService.signOutKeyModal = false;
            this.keyLogService.keyLoginKeyLogModal = null;
            this.keyLogService.corporationSettings = null;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            return;
        }

        const data: any = {
            building: {
                bdId: this.data.buildingId,
                name: this.data.buildingName ? this.data.buildingName : null,
            },
            suite: {
                bdId: this.data.suiteId ? this.data.suiteId : 0,
                suiteNumber: this.data.suiteNumber ? this.data.suiteNumber : this.data.otherSuite,
            },
            keyTag: this.data.keyTag,
            purpose: this.data.purpose,
            status: this.keyLogService.returnKeyModal ? 'available' : 'signet_out',
            notes: this.data.notes,
            activityNotes: form.value.activityNotes,
            user: {
                fullName: form.value.user
            }
        };

        if (form.value.sign) {
            if (!form.value.signBase) {
                toastr.warning('Signature should not be blank.');
                return;
            }
            data.signBase = form.value.signBase;
        }
        this.submitRequest(data);
    }

    submitRequest(data) {
        this.disabledSubmit = true;
        this.api.patch('domainKeyLog', `/v1/key_log/${this.data.id}.json`, data).subscribe(
            () => this.updateView((this.keyLogService.signOutKeyModal ? 'Signed key out' : 'Received key') +
                ' successfully'),
            error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Failed to ' + (this.keyLogService.signOutKeyModal ? 'sign out key' : 'received key'));
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.keyLogService.getData();
        this.form.reset();
        this.hideModal();
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/key-log/signOutReturnKeyModal/sign-out-return-key-modal.component.ts